import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { BackResponseFailure, Theme } from '@savgroup-front-common/types';
import { AuthConfiguration } from '@/configuration';

const ENDPOINT = `${APIConfiguration.catalogCDN}miscellaneous/themes/${AuthConfiguration.clientId}.json`;

const getClientTheme = async (): Promise<Theme | BackResponseFailure> => {
  try {
    const response = await fetch(ENDPOINT, {
      method: SUPPORTED_METHODS.GET,
    });

    return await response.json();
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getClientTheme;
